// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/style/reset.css
// module id = m0iu
// module chunks = 2